<div class="pagination pagination-ball">
    <span [ngClass]="{'is-active': flowControl == 1}"></span>
    <span [ngClass]="{'is-active': flowControl == 2}"></span>
    <span [ngClass]="{'is-active': flowControl == 3}"></span>
    <span [ngClass]="{'is-active': flowControl == 4}"></span>
    <span [ngClass]="{'is-active': flowControl == 5}"></span>
    <span [ngClass]="{'is-active': flowControl == 6}"></span>
    <span [ngClass]="{'is-active': flowControl == 7}"></span>
  </div>